import { cn } from "../../lib/utils"

const Checkbox = ({ className, ...props }: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">) => (
  <input
    type="checkbox"
    className={cn("h-4 w-4 cursor-pointer rounded-sm border border-input accent-primary focus-visible:outline-none focus-visible:border-ring", className)}
    {...props}
  />
)

export { Checkbox }
